import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
// -----------Routes------------------
import CommonRoutes from "Routes/Routes";
import ScrollToTop from "Utils/ScrollToTop";
import { addResponseInterceptor } from "Services/config";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";

import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { get_Years } from "Services/Requests";
import { useStore } from "Store";

export default function App() {
    const navigator = useNavigate();
    const { setmainStatus } = useStore((state: any) => state);

    //Setup response interceptor with navigation function
    addResponseInterceptor(navigator);

    // Fetch and update status values on app load
    useEffect(() => {
        const refreshStatusFromBackend = async () => {
            const token = localStorage.getItem("Token");
            const storedYearId = localStorage.getItem("Year_id");

            // Only call API if user is authenticated and has selected a year
            if (!token || !storedYearId) {
                return;
            }

            try {
                const response = await get_Years();

                if (response.data.status === 1 && response.data?.tax_file_years?.length > 0) {
                    // Filter by the stored Year_id
                    const selectedYear = response.data.tax_file_years.find(
                        (item: any) => item.id == storedYearId
                    );

                    if (selectedYear) {
                        // Update localStorage with fresh data from backend
                        localStorage.setItem("sub_status", selectedYear.sub_status);
                        localStorage.setItem("main_status", selectedYear.main_status);
                        localStorage.setItem("taxID", selectedYear.id);

                        // Update Zustand store
                        setmainStatus(selectedYear.main_status);
                    }
                }
            } catch (err) {
                // Silently fail - don't disrupt app loading if API fails
                console.error("Failed to refresh status from backend:", err);
            }
        };

        refreshStatusFromBackend();
    }, [setmainStatus]);

    return (
        <>
            <ToastContainer />

            <ScrollToTop />
            <Routes>
                <Route path="/*" element={<CommonRoutes />} />
            </Routes>
        </>
    );
}
//auth/payment-success/payment/success
